import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/logicplan.webp';
import screenshot_target from '../../../images/letterfunnel/erikjankerssies.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Erikjan Kerssies"
      firstname="Erikjan"
      companyname="Logicplan"
      competition="ORTEC en Simacan"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/erikjankerssies.js